import React from "react";
import { Link } from "react-router-dom";
import "./Footer.scss"

const Footer = () => {
    return (
        <>
            <section className="footer">
                <div className="container">
                    <div className="d-flex justify-content-between" style={{ alignItems: "center", }}>
                        <aside className="footer-left">
                            <p>Copyright © 2025 Gifts From Heaven. All rights reserved.</p>
                        </aside>
                        <aside className="footer-right">
                            <ul>
                                <li>
                                    <Link to="/terms-conditions">
                                        Terms & conditions
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/privacy-policy">
                                        Privacy policy
                                    </Link>
                                </li>
                            </ul>
                        </aside>
                    </div>
                </div>
            </section>
        </>

    )
}
export default Footer